<template>
	<div>
	    <van-nav-bar title="项目详情" left-text="返回" left-arrow @click-left="onClickLeft" fixed>
		<div slot="right">
			<span style="color:#1890ff;" @click="showPopup">详细</span>
		</div>
		</van-nav-bar>
		<div class="cardTop">
			<table class="layout">
			    <tr>
			        <td class="avatar-box" rowspan="4">
			            <img :src="avatarUrl + project.advisorIdavatar" class="avatar" alt="avatar">
			            <p class="advisor">{{project.advisorIdname}}</p>
			        </td>
			        <td colspan="2">
			            <div class="header">
			                <span class="title">{{project.name || "无"}}</span>
			            </div>
			        </td>
			    </tr>
			    <tr>
			        <td colspan="2" class="content">
			            <p v-for="field in displayField" :key="field.fieldName">
			                <span :class="icon + field.appIcon"></span>
			                <span>{{project[field.dictionary ? field.fieldName+'name':field.fieldName] || '无'}}</span>
			            </p>
			        </td>
			    </tr>
			</table>
		</div>
		<tabs :id="projectId" host="project" :advisorId="advisorId" :slotCount="slotCount">
		<template slot="left">
			<van-tab v-if="checkPermission('项目打卡记录')">
				<div slot="title">打卡记录</div>
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				  <van-list
					v-model="loading"
					:finished="finished"
					finished-text="没有更多了"
					@load="onLoad"
				  >
					<div v-for="(item,index) in list" class="card" :key="index">
						<div class="signedBox">
							<p>签到：</p>
							<div class="signRightBox">
								<p><span class="iconfont icon-date"></span><span>{{item.signInDateTime}}</span></p>
								<p><span class="iconfont icon-location"></span><span>{{item.signInAddress}}</span></p>
								<p><span class="iconfont icon-project"></span><span>{{item.projectName}}</span></p>
							</div>
						</div>
						<div class="signedBox" style="margin-top:15px;">
							<p>签退：</p>
							<div class="signRightBox">
								<p><span class="iconfont icon-date"></span><span>{{item.signOutDateTime}}</span></p>
								<p><span class="iconfont icon-location"></span><span>{{item.signOutAddress}}</span></p>
								<p><span class="iconfont icon-project"></span><span>{{item.projectName}}</span></p>
							</div>
						</div>
					</div>
				  </van-list>
				</van-pull-refresh>
			</van-tab>
		</template>	
		</tabs>
		
		<van-popup v-model="showTableGrid" position="right">
            <van-nav-bar title="详情" left-text="返回" left-arrow @click-left="cancel"></van-nav-bar>
             <table-grid table-name="crm_project" :data-id="projectId" :grouping="grouping" @savecomplate="cancel">
            </table-grid>
        </van-popup>
	</div>
</template>

<script>
	import {NavBar,Button,Toast,Icon,Dialog,Popup,Tab,Tabs,List,PullRefresh,} from 'vant';
	import moment from "moment";
	import saleChanceService from "../service/saleChanceService";
	import tabs from "../components/Tabs";
	import {API_URL} from "../common/config";
	import fieldDescriptionService from "../service/fieldDescriptionService";
	import projectService from "../service/projectService";
	import {formatDictionary} from "../utils/dictionary";
	export default {
		data() {
			return {
				projectId: '',
				showTableGrid: false,
				grouping: false,
				advisorId:'',
				project: {},
				displayField:[],
				dictionary: {},
				slotCount: 1,
				list: [],
				loading: false,
				finished: false,
				pageIndex: 0,
				refreshing: false,
			};
		},
		components: {
			tabs,
		    [NavBar.name]: NavBar,
			[Button.name]: Button,
			[Icon.name]: Icon,
			[Dialog.name]: Dialog,
			[Popup.name]: Popup,
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,
			[List.name]: List,
			[PullRefresh.name]: PullRefresh,
		},
		computed: {
		    avatarUrl() {
		        return API_URL + "/oa/common/attachment/showImage?id=";
		    },
		    icon() {
		        return "iconfont ";
		    }
		},
		created: async function() {
		    this.projectId = this.$route.query.uuid;
			this.advisorId = this.$route.query.advisorId;
			//this.project = JSON.parse(this.$route.query.project);
			this.dictionary = JSON.parse(this.$route.query.dictionary);
			this.load();
			if (this.displayField.length < 1){
			    let displayField = await fieldDescriptionService.getFieldDisplayOnAPP("crm_project");
			    if (displayField.data.Status === "1") {
			        this.displayField = displayField.data.Data;
			    }
			}
		},
		methods:{
			async load() {
				let resp = await projectService.getProjectById(this.projectId);
				if (resp.data.Status === "1") {
					formatDictionary([resp.data.Data], this.dictionary);
					resp.data.Data.createTime = moment(resp.data.Data.createTime).format('YYYY-MM-DD');
					this.project = resp.data.Data;
				}
			},
		    onClickLeft() {
		        this.$router.go(-1);
		    },
			cancel() {
				this.showTableGrid = false;
				this.load();
			},
			showPopup() {
				this.showTableGrid = true;
			},
			async onLoad() {
				this.pageIndex++;
				let res = await projectService.getAttendanceList(this.pageIndex,this.projectId);
				if (res.data.Status === "1") {
					formatDictionary(res.data.Data.data, res.data.Data.dictionary);
					this.loading = false;
					this.refreshing = false;
					this.list = [...this.list, ...res.data.Data.data];
					this.finished = res.data.Data.total <= this.list.length;
				}
			},
			onRefresh() {
				this.finished = false;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			},
		}
	}
</script>

<style>
	.van-popup--right {
	    width: 100%;
	    height: 100%;
	}
	.cardTop{
		margin-top:120px;
		padding: 1rem;
		font-size:0.8rem;
	}
	.signedBox {
		display: flex;
	}
	.signedBox>p{
		margin:0;
		flex:0 0 100px;
	}
	
	.signRightBox>p {
		margin: 0;
		margin-bottom:15px;
	}
	.signRightBox>p>span {
		color:#928f8f;
	}
	.signRightBox>p>span:last-child {
		margin-left:20px;
	}
</style>
